<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-9">
                    <div class="tab-content">
                        <div class="tab-pane active show" id="fizical-card">
                            <Store v-if="currentTab == 'fizical-card'" :addToCard="addToCard" />
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card custom-card card-body tx-white-8 bg-gray-800">
                        <h6>سبد خرید</h6>
                        <hr class="mb-4 mt-2">
                        <p v-if="!basket.length" class="text-center mb-0">سبد خرید خالی است</p>
                        <div v-else>
                            <div class="row mb-3" v-for="(card,index) in basket" :key="index">
                                <div class="col-md-4 pl-0">
                                    <img :src="!card.imageUrl.includes('base64') ? ('https://cardapi.sabinarya.com' + card.imageUrl) : card.imageUrl" class="w-100">
                                </div>
                                <div class="col-md-5">
                                    <p class="mb-1">{{ card.title }}</p>
                                    <p class="mb-1">تعداد: {{ card.count }}</p>
                                </div>
                                <div class="col-md-3">
                                    <button class="btn ripple btn-danger btn-icon float-left" @click="removeCard(index)"><i class="fe fe-minus"></i></button>
                                </div>
                            </div>
                            <hr class="mt-2 mb-4">
                            <button class="btn btn-success btn-block" v-if="chargesPrice == 0" @click="submit">تایید و ثبت سفارش</button>
                        </div>
                    </div>
                    <div class="card custom-card card-body tx-white-8 bg-gray-900" v-if="chargesPrice > 0">
                        <h6>ثبت اطلاعات پرداخت</h6>
                        <hr class="mb-4 mt-2">
                        <div class="form-group">
                            <label>شناسه پرداخت / شماره پیگیری</label>
                            <input type="tel" class="form-control ltr-input" v-model="paymentIdentifier" maxlength="30">
                        </div>
                        <div class="form-group">
                            <label>شماره ارجاع / شماره درخواست</label>
                            <input type="tel" :class="`form-control ltr-input ${rrn.length != 12 ? 'is-invalid' : ''}`" v-model="rrn" maxlength="12">
                        </div>
                        <button class="btn btn-success btn-block" @click="submit">تایید و ثبت سفارش</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Store from './_Store';
export default {
    name: 'Create',
    components: {Store},
    data(){
        return {
            nationalCode: '',
            maxLength: 10,
            customerDetails: {},
            legalCustomerDetails: {},
            customerId: 0,
            basket: [],
            currentTab: 'fizical-card',
            discount: 0,
            cardsPrice: 0,
            chargesPrice: 0,
            totalPrice: 0,
            displayedTotalPrice: 0,
            showLoading: false,
            paymentIdentifier: '',
            orderId: 0,
            rrn: ''
        }
    },
    watch: {
        discount: function(value){
            let discount = parseInt(value.toString().replace(/,/g,''));
            if(!this.discount)
                this.discount = 0;
            else if(this.totalPrice > discount)
                this.displayedTotalPrice = this.totalPrice - discount;
            else{
                this.discount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.totalPrice);
                this.displayedTotalPrice = 0;
            }
        }
    },
    methods: {
        setCurrentTab(tab){
            this.currentTab = tab;
        },
        numberFormat(){
            let value = this.amount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            if(this.amount.toString().replace(/,/g,'') > this.order.totalAmount)
                this.amount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.order.totalAmount);
            else
                this.amount = value;
        },
        addToCard(themeId,title,cardType,itemsCount,price,imageUrl){
            if(cardType == 1 || cardType == 2){
                let hasInBasket = this.basket.filter(item => item.themeId == themeId && item.cardType == cardType);
                if(hasInBasket.length){
                    let findIndex = this.basket.findIndex(item => item == hasInBasket[0]);
                    this.basket[findIndex].itemsCount = parseInt(this.basket[findIndex].itemsCount) + parseInt(itemsCount);
                }
                else
                    this.basket.push({
                        themeId,
                        mediaId: 0,
                        title: cardType == 1 ? title : (cardType == 2 ? (title + ' مجازی') : (cardType == 3 ? 'کارت هدیه مجازی' : 'کارت هدیه دلخواه')),
                        imageUrl,
                        count: parseInt(itemsCount),
                        price,
                        cardType
                    });
            }else
                this.basket.push({
                    themeId,
                    mediaId: 0,
                    title: cardType == 1 ? title : (cardType == 2 ? (title + ' مجازی') : (cardType == 3 ? 'کارت هدیه دلخواه' : 'کارت هدیه مجازی')),
                    imageUrl,
                    count: parseInt(itemsCount),
                    price,
                    cardType
                });
            this.calcTotalPrice();
        },
        calcTotalPrice(){
            let totalPrice = 0;
            this.chargesPrice = 0;
            this.cardsPrice = 0;
            this.basket.map(item => {
                this.cardsPrice += (item.price * item.count);
                totalPrice += (item.price * item.count);
            });
            this.totalPrice = totalPrice;
            let discount = parseInt(this.discount.toString().replace(/,/g,''));
            if(totalPrice > discount)                
                this.displayedTotalPrice = totalPrice - discount;
            else
                this.displayedTotalPrice = 0;
        },
        searchCustomer(){
            this.customerDetails = {};
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status){
                    this.legalCustomerDetails = data.result;
                    this.setCurrentTab('fizical-card');
                }
                this.customerId = data.result.customerId;
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        removeCard(itemIndex){
            let basket = this.basket.filter((item,index) => index != itemIndex);
            this.basket = basket;
            this.calcTotalPrice();
        },
        discountNumberFormat(){
            let value = this.discount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.discount = value;
        },
        changeCustomerType(){
            this.customerDetails = {};
            this.legalCustomerDetails = {};
            this.maxLength = this.customerType == 1 ? 10 : 11;
            this.nationalCode = '';
        },
        submit(){
            this.showLoading = true;
            this.$swal({
                icon: 'warning',
                title: 'توجه !',
                text: 'آیا از ثبت سفارش اطمینان دارید ؟',
                confirmButtonText: 'ثبت سفارش',
                showCancelButton: true,
                cancelButtonText: 'لغو'
            }).then((result) => {
                if(result.isConfirmed){
                    const postedData = {
                        themeOrderDetail: this.basket
                    };
                    this.$api.post('Themes/InsertOrder',postedData).then(({data}) => {
                        if(data.status)
                            this.$swal({
                                icon: 'success',
                                title: 'تبریک !',
                                text: 'ثبت سفارش با موفقیت انجام شد',
                            }).then(res => {
                                if(res.isConfirmed){
                                    this.$router.push({name: 'wareHouse.cardBody.index'});
                                }
                            });
                    }).catch(({response}) => {
                        let html = '';
                        response.data.errors.map(err => html += err.message + '<br>');
                        this.$swal({
                            icon: 'error',
                            title: 'خطا !',
                            html
                        });
                    }).finally(() => {
                        this.showLoading = false;
                    });
                }else
                    this.showLoading = false;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById('file-input').setAttribute('placeholder',file.name);
        }
    }
}
</script>
